import React from "react";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import { displayPercentage } from "../../utils/data";

const DashboardBar = (props) => {
  const { title, value, percentage, colors, idToWatch } = props;
  const [containerWidth, setContainerWidth] = React.useState(275);

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    handleResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToWatch]);

  const handleResize = () => {
    if (idToWatch) {
      const width = get(document.getElementById(idToWatch), ["offsetWidth"]);
      setContainerWidth(width - 120);
    }
  };

  return (
    <Grid container direction="column" style={{ ...props.style }}>
      <Grid item className="text-87 bold-500">
        {title}
      </Grid>
      <Grid item>
        <Grid container alignItems="flex-end">
          <Grid
            item
            style={{
              width: "100px",
              lineHeight: "28px",
              height: "28px",
            }}
          >
            <span
              className="text-87 bold-500"
              style={{
                fontSize: "2em",
                marginRight: "5px",
              }}
            >
              {value}
            </span>
            <span>{displayPercentage(percentage)}</span>
          </Grid>
          <Grid
            item
            style={{
              backgroundColor: colors[0],
              borderTopLeftRadius: "2px",
              borderBottomLeftRadius: "2px",
              height: "20px",
              width: `${percentage * containerWidth}px`,
            }}
          />
          <Grid
            item
            style={{
              backgroundColor: colors[1],
              borderTopRightRadius: "2px",
              borderBottomRightRadius: "2px",
              height: "20px",
              width: `${(1 - percentage) * containerWidth}px`,
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashboardBar;
